<template>
  <div class="bq-product-hlwyy">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="title-desc">
      通过搭建互联网诊疗平台，为患者提供在线问诊、线上复诊、处方流转、居家护理等互联网在线诊疗服务，患者足不出户就可实现线上就诊。
    </p>
    <div class="hlwyy-descs">
      <div class="descs-left">
        <div>
          <h3>在线问诊</h3>
          <p>
            支持患者向线上互联网医院医生发起在线问诊，包括图文、语音等形式；
          </p>
        </div>
        <div>
          <h3>居家护理</h3>
          <p>
            患者可线上申请换药、腹透、输液等专科护理服务，线上医院确认后至现场为患者提供服务；
          </p>
        </div>
      </div>
      <div class="descs-mid">
        <div>
          <h3>线上复诊</h3>
          <p>
            针对复诊/常见病患者，可直接通过互联网医院发起线上诊疗，由医生诊断后开具诊断意见及线上处方；
          </p>
        </div>
        <div>
          <h3>管理后台</h3>
          <p>
            院方能通过管理后台开展互联网医院的信息维护、运营分析及业务监管等功能，以实现及时维护与监管业务。
          </p>
        </div>
      </div>
      <div class="descs-right">
        <div>
          <h3>处方流转</h3>
          <p>
            针对线上开具的电子处方，患者可选择流转至线上药房/DTP药房进行配送，也可自行到线下进行取药；
          </p>
        </div>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="hlwyy-adv">
      <InfoBox
        :col="3"
        :itemObj="item"
        v-for="item in datalist"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'hlwyy',
  data() {
    return {
      rightArrow:
        'https://img.alicdn.com/tfs/TB1VDuoDUY1gK0jSZFMXXaWcVXa-36-16.png',
      datalist: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1AJ9fF4v1gK0jSZFFXXb0sXXa-86-84.png',
          advTitles: '轻量化应用',
          advDesc:
            '患者端基于支付宝/微信小程序，医护端基础钉钉端，用户都无需下载任何应用，更加便捷。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1GrufF4D1gK0jSZFKXXcJrVXa-86-88.png',
          advTitles: '链路完整',
          advDesc:
            '从在线问诊到处方流转，从患者端到医护端到医院管理层，保证了互联网诊疗的链路完整性。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB19FWhFW61gK0jSZFlXXXDKFXa-92-68.png',
          advTitles: '协同应用',
          advDesc: '协同智能导诊、诊前助手等工具类应用。',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-hlwyy {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .hlwyy-descs {
    display: flex;
    justify-content: space-between;
    padding-top: 54px;
    padding-bottom: 90px;
    color: #333;

    & > div {
      width: 300px;
      & > div {
        min-height: 150px;
        margin-bottom: 60px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    h3 {
      font-size: 20px;
      margin-bottom: 20px;
    }
    p {
      font-size: 18px;
    }
    .descs-left {
      margin-right: 28px;
    }
    .descs-mid {
      padding: 0 35px 0 38px;
      width: 335px;
      flex: 0 0 325px;
      border-left: 2px solid #aeaeae;
      border-right: 2px solid #aeaeae;
      margin-bottom: 0;
    }

    .descs-right {
      margin-left: 38px;
    }
  }

  .hlwyy-adv {
    display: flex;
    justify-content: space-between;
    .bq-infobox {
      width: 252px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    padding-bottom: 0;
    margin-bottom: 60px;
  }
}
</style>
